<template>
  <b-dropdown size="md" variant="link" toggle-class="text-decoration-none" no-caret>
    <template #button-content>
      <div
        class="__priorities__container d-flex align-items-center px-2 py-1 justify-content-center"
        :style="`color:${currentValue.color}; border:1px solid ${currentValue.color}; border-radius:3px;`"
      >
        <i :class="currentValue.img" :style="`color:${currentValue.color};`"></i>
        {{ currentValue.value }}
      </div>
    </template>
    <b-dropdown-item v-for="item in items" :key="item.id" @click="changeValue(item.id)">
      <span class="d-flex align-items-center" :style="`color:${item.color};`">
        <i :class="item.img"></i>
        {{ item.value }}
      </span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { teamTaskMixins } from '../../utils/mixins'
export default {
  mixins: [teamTaskMixins],
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      currentValue: null,
    }
  },
  beforeMount() {
    this.findDefaultValue()
  },
  methods: {
    changeValue(id) {
      let oldPriority = this.currentValue
      this.currentValue = this.items.find((el) => el.id === id)
      let newPriority = this.currentValue
      this.$emit('priorityUpdated', {old:oldPriority,new:newPriority})
    },
    findDefaultValue() {
      this.currentValue = this.items.find((el) => {
        return this.teamtaskDetail.priority == el.id
      })
    },
  },
}
</script>

<style scoped>
::v-deep .__priorities {
  /* position: relative; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .__priorities__container {
  position: relative !important;
  display: flex;
  align-items: center;
  height: 33px !important;
  width: 141px !important;
  border-radius: 3px !important;
}
::v-deep .dropdown-toggle .btn {
  padding: 0 !important;
}

i {
  font-size: 16px !important;
  margin-left: 2px;
}
</style>
